'use strict';

var $ = require('jquery');

module.exports = {
  $el: null,

  init: function init(el) {
    this.$el = $(el);

    if (this.$el.length) {
      this.bindUiActions();
    }
  },
  bindUiActions: function bindUiActions() {
    var _this = this;
    var $filter = _this.$el.find('#filter');
    var count = 0;

    this.$el.find('.device-item').click(function (e) {
      window.location.href = $(e.currentTarget).data('link');
    });

    if ($filter.length !== 0) {
      $filter.keyup(function () {
        count = 0;
        $('#dev-table tr').each(function () {
          if ($(this).find('a:first').text().search(new RegExp($filter.val(), 'i')) < 0) {
            $(this).addClass('hidden');
          } else {
            $(this).removeClass('hidden');
            count++;
          }
        });

        $('#filter-count').text(count);
      });
    }
  }
};
